module.exports = __webpack_public_path__ + "img/special.c5544d0.svg";